import React, { useEffect, useState } from "react";
import {
  Layout,
  Dropdown,
  Avatar,
  Menu,
  Input,
  Typography,
  theme,
  Divider,
  Badge,
} from "antd";
import styles from "./header.module.css";
import { setCookie } from "../../utils/cookie-storage/cookie-storage";
import SVGIcon from "../../constants/SVGIcon";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { MenuFoldOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import NotificationPanel from "../../components/notification/notification-panel";
import { useRef } from "react";
import {
  getNotificationList,
  getNotificationListCount,
} from "../../services/header";
const { Header: AntHeader } = Layout;

export function Header({ collapsed, toggleCollapsed }) {
  const panelRef = useRef();
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [visible, setVisible] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      setCookie("auth-token", token);
    }
  }, []);

  const user = useSelector((state) => state.user?.user);
  useEffect(() => {
    function handleClickOutside(e) {
      if (visible && panelRef.current && !panelRef.current.contains(e.target)) {
        setVisible(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [visible]);

  useEffect(() => {
    const fetchNotificationsCounts = async () => {
      try {
        const response = await getNotificationListCount();
        setNotificationsCount(response.data.data);
      } catch (err) {
        console.error("Error fetching notifications Count:", err);
      }
    };

    fetchNotificationsCounts();
  }, []);

  const fetchNotifications = async () => {
    try {
      const response = await getNotificationList(page, pageSize);
      const newNotifications = response?.data?.data?.notifications || [];

      if (newNotifications.length < pageSize) {
        setHasMore(false);
      }

      setNotifications((prev) => [...prev, ...newNotifications]);
      setPage((prev) => prev + 1);
    } catch (err) {
      console.error("Error fetching notifications:", err);
    }
  };
  useEffect(() => {
    fetchNotifications();
  }, []);
  return (
    <AntHeader className={styles.header}>
      <div className={styles.logoTitleContainer}>
        <div className={styles.triggerIcon} onClick={toggleCollapsed}>
          {collapsed ? (
            <MenuFoldOutlined width="20" height="20" />
          ) : (
            <MenuUnfoldOutlined width="20" height="20" />
          )}
        </div>

        <div className={styles.logoContainer}>
          <Link to="/">
            <img
              src={
                user?.role === "SUPER-ADMIN"
                  ? "assets/images/nzminds_full_logo.svg"
                  : user?.institution_logo
                  ? user.institution_logo
                  : "assets/images/sample-school.jpg"
              }
              alt="LOGO"
              height={user?.role === "SUPER-ADMIN" ? "60px" : "43px"}
              width={user?.role === "SUPER-ADMIN" ? "150px" : "43px"}
            />
          </Link>
          {!(user?.role === "SUPER-ADMIN") && (
            <Typography className={styles.logoTitle}>
              {user?.institution?.institution_name ?? "Sample School"}
            </Typography>
          )}
        </div>

        <Typography className={styles.welcomeTitle}>
          Welcome{" "}
          {user?.role === "SUPER-ADMIN"
            ? "Super Admin"
            : user?.metadata?.full_name}
          !
        </Typography>
      </div>
      <div className={styles.profile}>
        <Avatar
          style={{
            cursor: "pointer",
            width: "33px",
            height: "33px",
            backgroundColor: "#EAECF0",
          }}
          icon={
            <SVGIcon
              name="message-icon"
              width={"16"}
              height={"16"}
              fill="#EAECF0"
              stroke="var(--primary-color)"
            />
          }
        />
        <Avatar
          style={{
            cursor: "pointer",
            width: "33px",
            height: "33px",
            backgroundColor: "#EAECF0",
          }}
          icon={
            <SVGIcon
              name="phone-icon"
              width={"16"}
              height={"16"}
              fill="#EAECF0"
              stroke="var(--primary-color)"
            />
          }
        />

        <div ref={panelRef}>
          <Badge count={notificationsCount} color={"var(--primary-color)"}>
            <Avatar
              style={{
                cursor: "pointer",
                width: "33px",
                height: "33px",
                backgroundColor: "#EAECF0",
              }}
              icon={
                <SVGIcon
                  name="notification-icon"
                  width={"16"}
                  height={"16"}
                  fill="#EAECF0"
                  stroke="var(--primary-color)"
                />
              }
              onClick={() => setVisible((prev) => !prev)}
            />
          </Badge>

          {visible && (
            <>
              <div
                className={styles.notification_overlay}
                onClick={() => setVisible(false)}
              />
              <NotificationPanel
                notifications={notifications}
                fetchNotifications={fetchNotifications}
                hasMore={hasMore}
                onClose={() => setVisible(false)}
              />
            </>
          )}
        </div>
      </div>
    </AntHeader>
  );
}

export default Header;
